"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.array.concat.js");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

// domain域名
var reg = /^(\d+)(\.(\d+)){3}$/; //直接ip地址的和localhost直接输出

var hostname = location.hostname === 'localhost' || reg.test(location.hostname) ? location.hostname : ".".concat(location.hostname.split('.').slice(-2).join('.'));
/**
 * @function Cookie[get] - 获取cookie
 * @desc 获取cookie
 * @example
 * import { Cookie } from '@zz-biz/utils';
 * 
 * Cookie.get('t');
 * // return 50
 * @return {string}
 */

var get = function get(key) {
  return _jsCookie["default"].get(key);
};
/**
 * @function Cookie[set] - 设置cookie
 * @desc 设置cookie
 * @param {string} key 关键字
 * @param {string} value 存储值
 * @param {object} [options={}] 属性
 * @param {number} [options.expires=90] 存储事件, 单位天
 * @param {string} [options.path=/] 存储路径，默认根目录
 * @param {string} [options.hostname=.zhuanzhuan.com] 存储域名
 * @example
 * import { Cookie } from '@zz-biz/utils';
 * Cookie.set('t', 50);
 */


var set = function set(key, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    expires: 90,
    path: '/',
    domain: hostname
  };

  if (key === 'PPU' || key === 'ZZU') {
    var exp = new Date().getTime() + 1000 * 3600 * 24 * options.expires;
    document.cookie = "".concat(key, "=\"").concat(value, "\"; domain=").concat(options.domain, "; path=").concat(options.path, "; expires=").concat(new Date(exp).toUTCString());
  } else {
    _jsCookie["default"].set(key, value, options);
  }
};
/**
 * @function Cookie[remove] - 删除cookie
 * @desc 删除某个cookie
 * @example
 * import { Cookie } from '@zz-biz/utils';
 * Cookie.remove('t');
 */


var remove = function remove(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    path: '/',
    domain: hostname
  };

  _jsCookie["default"].remove(name, options);
};

var _default = {
  get: get,
  set: set,
  remove: remove
};
exports["default"] = _default;